import { render, staticRenderFns } from "./VueDropzone.vue?vue&type=template&id=34d2a576"
import script from "./VueDropzone.vue?vue&type=script&lang=js"
export * from "./VueDropzone.vue?vue&type=script&lang=js"
import style0 from "./VueDropzone.vue?vue&type=style&index=0&id=34d2a576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports